const CompanyRelatedObject = {
    companies:[]
  }
  
  export default CompanyRelatedObject